<template>
    <div class="flats-find-num">
        <div class="msg" v-if="globalLang != 'kz/'">Найдено {{ filterFlatsDataBase.filter_items_count }} {{correctWord}}</div>
        <div class="msg" v-if="globalLang == 'kz/'">{{ filterFlatsDataBase.filter_items_count }} пәтер табылды</div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'flats-find-num',
        components: {
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                correctWord: null,
            }
        },
        computed: mapGetters({
            filterFlatsDataBase: 'loadFilterFlatsData',
        }),
        methods: {
            correctFindWord() {
                function pluralizeWord(number, word) {
                    const lastDigit = number % 10;
                    if (number == 1) {
                        return word + "а"; // Для чисел, заканчивающихся на 1 или 8
                    } else if (lastDigit >= 2 && lastDigit <= 4) {
                        return word + "ы"; // Для чисел, заканчивающихся на 2-4
                    } else {
                        return word + ""; // Для всех остальных чисел
                    }
                }
                const word = 'квартир';
                this.correctWord = pluralizeWord(this.filterFlatsDataBase.filter_items_count, word);
            }
        },
        created () {
            this.correctFindWord();
        },
        mounted() {
            this.$store.watch(
                (state) => state.filterFlats_Data.filter_items_count,
                (newValue) => {
                    if (newValue) {
                        this.correctFindWord();
                    }
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-page/flats-find-num.scss';
    @import '@/styles/components/flats-page/respond/flats-find-num-respond.scss';
    // @import '@/styles/components/commerce-page/respond/commerce-find-num-respond.scss';
</style>